import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AdminReturnRequestState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
}

const initialFilterData = {
  type: 'return',
  request_status: '',
  search: '',
  order_number: '',
};

const initialState: AdminReturnRequestState = {
  filterData: initialFilterData,
  reloadTableData: false,
};

const adminReturnRequestSlice = createSlice({
  name: 'adminReturnRequest',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    removeFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetFilterData(state) {
      state.filterData = initialFilterData;
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
  },
});

export const { setFilterData, removeFilterKey, resetFilterData, setReloadTableData } =
  adminReturnRequestSlice.actions;

export default adminReturnRequestSlice.reducer;
